export default {
  NAVIGATION: 'navigation',
  PAGINATION: 'pagination',
  TRANSITION: 'transition',
  AUTO_CHANGE: 'autoChange',
  AUTO_CHANGE_DELAY: 'autoChangeDelay',
};
